/**
 * Catálogo de texto en español para la función de comercio
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Las claves reflejan las llamadas `t('commerce.*')` en los componentes React de la función.
 * Los valores son las cadenas exactas originales en español extraídas durante el barrido i18n.
 */
export const commerceEs = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Reclama tu biblioteca',
  'commerce.dtrpg.seoDescription': 'Importa tu biblioteca de DriveThruRPG y reclama tus PDFs de Grymwyrd.',
  'commerce.dtrpg.heading': 'Reclama tu biblioteca',
  'commerce.dtrpg.intro':
    '¿Compraste Grymwyrd en DriveThruRPG o respaldaste la campaña? Inicia sesión con tu correo de compra para importar tu biblioteca y reclamar tus copias.',
  'commerce.dtrpg.sendLinkError': 'No pudimos enviar tu enlace de inicio de sesión en este momento. Intenta de nuevo en breve.',
  'commerce.dtrpg.checkInboxPrefix': 'Comprueba tu bandeja de entrada en',
  'commerce.dtrpg.checkInboxSuffix':
    'Si ese correo compró o respaldó Grymwyrd, un enlace de inicio de sesión está en camino — haz clic para volver aquí y reclamar tu biblioteca.',
  'commerce.dtrpg.linkAutoSignIn': 'El enlace te inicia sesión automáticamente — no necesitas contraseña.',
  'commerce.dtrpg.purchaseEmailLabel': 'Tu correo de compra / promesa',
  'commerce.dtrpg.sendingLink': 'Enviando enlace…',
  'commerce.dtrpg.emailLinkCta': 'Envíame un enlace de inicio de sesión',
  'commerce.dtrpg.signedInAs': 'Sesión iniciada como',
  'commerce.dtrpg.signOut': 'Cerrar sesión',
  'commerce.dtrpg.dtrpgEmailLabel': 'Correo de DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(opcional — si es diferente del anterior)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Usamos esto para coincidencia tus compras de DriveThruRPG al conceder tu biblioteca.',
  'commerce.dtrpg.libraryHeading': 'Tu biblioteca de Grymwyrd',
  'commerce.dtrpg.noTitles': 'Aún no se han configurado títulos importables.',
  'commerce.dtrpg.claimNotInLibrary':
    'Este título aún no está en tu biblioteca. Asegúrate de haber usado el correo de compra correcto.',
  'commerce.dtrpg.claimSessionExpired': 'Tu sesión ha expirado — inicia sesión de nuevo.',
  'commerce.dtrpg.claimError': 'No se pudo reclamar este título en este momento. Por favor, intenta de nuevo.',
  'commerce.dtrpg.preparingCopy': 'Preparando tu copia…',
  'commerce.dtrpg.download': 'Descargar',
  'commerce.dtrpg.preparing': 'Preparando…',
  'commerce.dtrpg.claiming': 'Reclamando…',
  'commerce.dtrpg.claim': 'Reclamar',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'No se pudo abrir el carrito de compra. Por favor, intenta de nuevo pronto.',
  'commerce.paywall.signInToPurchase': 'Inicia sesión para completar esta compra.',
  'commerce.paywall.vaultSealed': 'La bóveda del mercader está sellada por ahora — intenta de nuevo pronto.',
  'commerce.paywall.signInToUnlock': 'Inicia sesión para desbloquear',
  'commerce.paywall.comingSoonTitle': 'Esta compra llega pronto',
  'commerce.paywall.priceComingSoon': '{price} — llega pronto',
  'commerce.paywall.comingSoon': 'Llega pronto',
  'commerce.paywall.openingVault': 'Abriendo la bóveda…',
  'commerce.paywall.unlockPrice': 'Desbloquear — {price}',
  'commerce.paywall.unlock': 'Desbloquear',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': 'Se instaló "{name}" en tu mesa.',
  'commerce.marketplace.installNotOwned': 'Aún no eres dueño de este paquete — la compra de paquetes llegará pronto.',
  'commerce.marketplace.installHostOnly': 'Solo el anfitrión de la mesa puede instalar un paquete.',
  'commerce.marketplace.installError': 'No se pudo instalar este paquete. Por favor, intenta de nuevo.',
  'commerce.marketplace.installed': 'Instalado',
  'commerce.marketplace.installing': 'Instalando…',
  'commerce.marketplace.installOnTable': 'Instalar en la mesa',
  'commerce.marketplace.seoTitle': 'Mercado — Paquetes',
  'commerce.marketplace.seoDescription':
    'Explora e instala paquetes de contenido creador — mapas, escenas, documentos de jugador y preajustes — en tus mesas.',
  'commerce.marketplace.eyebrow': 'Mercado',
  'commerce.marketplace.heading': 'Paquetes de contenido',
  'commerce.marketplace.intro':
    'Mapas, escenas, documentos de jugador y preajustes de inicio rápido — instálalos en tus mesas con un clic.',
  'commerce.marketplace.installingOnto': 'Instalando en la mesa {tableId}.',
  'commerce.marketplace.signInHeading': 'Inicia sesión para ver tus paquetes',
  'commerce.marketplace.signInBlurb': 'El catálogo de paquetes está vinculado a tu cuenta de creador.',
  'commerce.marketplace.signIn': 'Inicia sesión',
  'commerce.marketplace.loading': 'Invocando tus paquetes…',
  'commerce.marketplace.noPacksHeading': 'Aún no hay paquetes',
  'commerce.marketplace.noPacksBlurb':
    'Aún no has publicado ningún paquete. Un mercado público para explorar los paquetes de otros creadores llegará pronto.',
  'commerce.marketplace.footer': 'La exploración de paquetes de otros creadores y paquetes de pago están en camino.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Mesas solo para suscriptores',
  'commerce.subscriber.perk1Blurb': 'Siéntate en mesas que tus anfitriones favoritos reservan para suscriptores.',
  'commerce.subscriber.perk2Title': 'Contenido temprano y exclusivo',
  'commerce.subscriber.perk2Blurb': 'Obtén capítulos de campaña, escenas y documentos de jugador antes que nadie.',
  'commerce.subscriber.perk3Title': 'Insignia de suscriptor',
  'commerce.subscriber.perk3Blurb': 'Una marca de distinción en tu perfil y en la mesa.',
  'commerce.subscriber.seoTitle': 'Ventajas de suscriptor',
  'commerce.subscriber.seoDescription':
    'Suscríbete para obtener mesas exclusivas, contenido temprano e insignia de suscriptor.',
  'commerce.subscriber.heading': 'Conviértete en suscriptor',
  'commerce.subscriber.intro':
    'Apoya a los anfitriones y creadores que amas — y desbloquea las ventajas que reservan para su coven interno.',
  'commerce.subscriber.activeHeading': 'Eres un suscriptor',
  'commerce.subscriber.activeBlurb':
    'Tus ventajas están activas. Busca la cresta de suscriptor en las mesas a las que puedas unirte.',
  'commerce.subscriber.findTable': 'Encuentra una mesa de suscriptor',
  'commerce.subscriber.paywallTitle': 'Suscriptor de Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Desbloquea mesas solo para suscriptores, contenido temprano e insignia de suscriptor.',
  'commerce.subscriber.paywallPrice': 'desde 5 €/mes',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'No se pudo abrir el carrito de compra. Por favor, intenta de nuevo pronto.',
  'commerce.ticket.signInToBuy': 'Inicia sesión para comprar un asiento en esta mesa.',
  'commerce.ticket.boxOfficeClosed': 'La taquilla está cerrada por ahora — intenta de nuevo pronto.',
  'commerce.ticket.seoTitle': 'Compra un asiento',
  'commerce.ticket.seoDescription': 'Reserva tu asiento en una mesa de entrada.',
  'commerce.ticket.eyebrow': 'Mesa de entrada',
  'commerce.ticket.heading': 'Reserva tu asiento',
  'commerce.ticket.loading': 'Cargando la mesa…',
  'commerce.ticket.notFoundHeading': 'Mesa no encontrada',
  'commerce.ticket.notFoundBlurb': 'Esta mesa puede haber cerrado, o sus puertas nunca se abrieron.',
  'commerce.ticket.backToLobby': 'Volver al vestíbulo',
  'commerce.ticket.freeHeading': 'Esta mesa es gratuita para unirse',
  'commerce.ticket.freeBlurb': 'No se requiere entrada — acércate una silla.',
  'commerce.ticket.goToLobby': 'Ir al vestíbulo',
  'commerce.ticket.untitledTable': 'Mesa sin título',
  'commerce.ticket.seatPrice': 'Precio del asiento',
  'commerce.ticket.spectatorsNote': 'Los espectadores también deben tener una entrada para esta mesa.',
  'commerce.ticket.paymentReceived': 'Pago recibido — tu asiento está reservado. Dirígete al vestíbulo para ocuparlo.',
  'commerce.ticket.signInToBuySeat': 'Inicia sesión para comprar un asiento',
  'commerce.ticket.openingBoxOffice': 'Abriendo la taquilla…',
  'commerce.ticket.buySeatPrice': 'Comprar asiento — {price}',
  'commerce.ticket.comingSoonTitle': 'Las entradas llegan pronto',
  'commerce.ticket.ticketingComingSoon': 'Entradas llegando pronto',
  'commerce.ticket.comingSoonFooter': 'Los asientos de pago casi están listos. Por ahora, pídele al anfitrión una invitación gratuita.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Solo el anfitrión de la mesa puede gestionar objetivos.',
  'commerce.tip.errHostOnlyBounty': 'Solo el anfitrión de la mesa puede gestionar recompensas.',
  'commerce.tip.errMaxGoal': 'Has alcanzado el número máximo de objetivos para esta mesa.',
  'commerce.tip.errMaxBounty': 'Has alcanzado el número máximo de recompensas para esta mesa.',
  'commerce.tip.errMissingGoal': 'Ese objetivo no tiene los detalles requeridos.',
  'commerce.tip.errMissingBounty': 'Esa recompensa no tiene los detalles requeridos.',
  'commerce.tip.errSignIn': 'Inicia sesión como anfitrión para gestionar esta mesa.',
  'commerce.tip.errSaveFailedGoal': 'No se pudo guardar el objetivo. Por favor, intenta de nuevo.',
  'commerce.tip.errSaveFailedBounty': 'No se pudo guardar la recompensa. Por favor, intenta de nuevo.',
  'commerce.tip.goalValidation': 'Añade una etiqueta y un objetivo de dinero positivo.',
  'commerce.tip.goalAdded': 'Objetivo "{label}" añadido.',
  'commerce.tip.goalLabelPlaceholder': 'Etiqueta de objetivo (p. ej. Invoca al jefe)',
  'commerce.tip.targetPlaceholder': 'Objetivo €',
  'commerce.tip.cuePlaceholder': 'Señal al alcanzarse (p. ej. fanfarria)',
  'commerce.tip.addGoal': 'Añadir objetivo',
  'commerce.tip.bountyValidation': 'Añade una etiqueta, un objetivo positivo y un activador.',
  'commerce.tip.bountyAdded': 'Recompensa "{label}" añadida.',
  'commerce.tip.bountyLabelPlaceholder': 'Etiqueta de recompensa (p. ej. Nat 20 salva al grupo)',
  'commerce.tip.triggerPlaceholder': 'Activador (p. ej. un 20 natural)',
  'commerce.tip.addBounty': 'Añadir recompensa',
  'commerce.tip.signInToManage': 'Inicia sesión para gestionar esta mesa.',
  'commerce.tip.bountyClaimed': 'Recompensa "{label}" reclamada.',
  'commerce.tip.seoTitle': 'Objetivos de propina y recompensas',
  'commerce.tip.seoDescription': 'Establece objetivos de propina y recompensas para tu mesa.',
  'commerce.tip.backToLobby': 'Volver al vestíbulo',
  'commerce.tip.heading': 'Objetivos de propina y recompensas',
  'commerce.tip.intro':
    'Establece objetivos y recompensas para tu mesa. Cuando la taza se desborde, la señal se activa para tu audiencia. La pantalla de retransmisión la maneja tu superposición de transmisión.',
  'commerce.tip.loading': 'Leyendo el libro de cuentas…',
  'commerce.tip.loadErrorTitle': 'No se pudo cargar el libro de cuentas',
  'commerce.tip.raisedSoFar': 'Recaudado hasta ahora:',
  'commerce.tip.tipGoalsHeading': 'Objetivos de propina',
  'commerce.tip.noGoals': 'Sin objetivos aún — añade el primero a continuación.',
  'commerce.tip.reachedAria': 'alcanzado',
  'commerce.tip.bountiesHeading': 'Recompensas',
  'commerce.tip.noBounties': 'Sin recompensas aún — añade la primera a continuación.',
  'commerce.tip.whenLabel': '· cuando: {trigger}',
  'commerce.tip.claimed': 'Reclamado',
  'commerce.tip.claimTitleReady': 'Marca esta recompensa como reclamada',
  'commerce.tip.claimTitleNotFunded': 'Aún no financiada',
  'commerce.tip.claim': 'Reclamar',
} as const
